import { createElement, lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import { forEach, snakeCase } from 'lodash'

const EditBlock = lazy(() => import('../edit_block'))
import { SIDE_BAR_BLOCKS as BLOCKS } from '../../constants'

import styles from './index.css'

let blocks = {}
forEach(BLOCKS, (_, name) => {
  const file = snakeCase(name)
  blocks[name] = lazy(() => import(`../${file}`))
})

const Block = ({ name, data, metadata, isEditable }) => {
  return (
    <Suspense fallback={<span></span>}>
      <div className={styles.base}>
        {isEditable && <EditBlock name={name} />}
        {createElement(blocks[name], { name, data, metadata })}
      </div>
    </Suspense>
  )
}

Block.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.object,
  metadata: PropTypes.object,
  isEditable: PropTypes.bool
}

export default Block
